import React from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import { useTheme } from "context/theme-context";

/**
 * Light / dark switch. A sliding thumb shows the active mode; the whole
 * control is one switch so it stays keyboard and screen-reader friendly.
 */
export const ThemeToggle = ({ className = "", compact = false }: { className?: string; compact?: boolean }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  if (compact) {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={isDark}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        onClick={toggleTheme}
        className={`zs-icon-btn ${className}`}
        data-testid="theme-toggle"
      >
        {isDark ? <FiMoon className="w-[18px] h-[18px]" /> : <FiSun className="w-[18px] h-[18px]" />}
      </button>
    );
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
      onClick={toggleTheme}
      className={`zs-theme-toggle ${className}`}
      data-testid="theme-toggle"
    >
      <span className="zs-theme-toggle-thumb" aria-hidden="true" />
      <span className={`zs-theme-toggle-icon ${!isDark ? "is-active" : ""}`} aria-hidden="true">
        <FiSun />
      </span>
      <span className={`zs-theme-toggle-icon ${isDark ? "is-active" : ""}`} aria-hidden="true">
        <FiMoon />
      </span>
    </button>
  );
};

export default ThemeToggle;
